import React, { FC } from "react";

import DialogWizard from "../DialogComponents/DialogWizard/DialogWizard";
import { NewLayerAttributes } from "./NewLayerAttributes";
import { NewLayerResource } from "./NewLayerResource";

export const NewLayerSteps: FC = () => {
  return <DialogWizard steps={[NewLayerResource, NewLayerAttributes]} />;
};
